import React from "react";
import Footer from "./Footer";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";
import Header from "./Header";

function formatJustLandedPrice(price) {
  const num = Number.parseFloat(String(price), 10);
  if (Number.isNaN(num)) return price;
  return `£${Math.round(num)}`;
}

function Shop() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="shop main">
      <Header />
      <section
        className="main-spring-dresses"
        aria-labelledby="main-spring-dresses-heading"
      >
        <div className="main-spring-dresses__head">
          <h2
            id="main-spring-dresses-heading"
            className="main-spring-dresses__title"
          >
            Shop Now
          </h2>
        </div>
        <div className="main-spring-dresses__grid">
          {productData.map((product) => (
            <article key={product.id} className="main-spring-dresses__card">
              <Link
                className="main-spring-dresses__link"
                to={`/shopDetails/${product.id}`}
                onClick={toTop}
              >
                <div className="main-spring-dresses__img-wrap">
                  {product.springBreakQuickView ? (
                    <span
                      className="main-spring-dresses__quick"
                      aria-hidden="true"
                    >
                      <svg
                        className="main-spring-dresses__quick-icon"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.6"
                      >
                        <circle cx="11" cy="11" r="7" />
                        <path d="M20 20l-4-4" strokeLinecap="round" />
                      </svg>
                    </span>
                  ) : null}
                  <img src={product.image} alt={product.name} loading="lazy" />
                </div>
                <h3 className="main-spring-dresses__name">{product.name}</h3>
                <p className="main-spring-dresses__price">
                  {formatJustLandedPrice(product.price)}
                </p>
              </Link>
            </article>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Shop;
